
import { normalize } from 'normalizr';
import { customizationObject } from '../schemas/projectSchema';

const customizationUpdate = (customizationUUID, customizationData, actions) => (
  // TODO: this can be abstracted later
  fetch(`/web-api/v2/card-project/customization/${customizationUUID}`, {
    method: 'PUT',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(customizationData)
  })
    .then((response) => {
      if (!response.ok) return { type: actions.failure };
      return response;
    })
    .then(response => response.json()).then((data) => {
      const normalizedPayload = normalize(data, customizationObject);
      return {
        type: actions.success,
        payload: { customization: normalizedPayload }
      };
    })
    .catch(err => ({ type: actions.failure, payload: err }))
);


const api = {
  customizationUpdate,
};
export default api;



// WEBPACK FOOTER //
// ./src/cards/services/api.js